import React from 'react';
import { Avatar } from '@domain-group/fe-blueprint-ui/avatar';
import { EmailIcon } from '@domain-group/fe-co-icon';
import { AverageStarRatingAndTotal } from '@domain-group/fe-co-allhomes-average-star-rating-and-total';
import { Button, CallButton, Separator } from '@domain-group/fe-co-allhomes-design-system';
import { AllhomesNonEuUser } from '@domain-group/fe-co-allhomes-eu-user';
import * as styles from './sidebox-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var SideboxCard = _ref => {
  var agencyLogo = _ref.agencyLogo,
    agencyLogoBackgroundColour = _ref.agencyLogoBackgroundColour,
    profilePhoto = _ref.profilePhoto,
    name = _ref.name,
    title = _ref.title,
    isEmailContactable = _ref.isEmailContactable,
    phoneNumber = _ref.phoneNumber,
    agencyProfileUrl = _ref.agencyProfileUrl,
    reviewProfile = _ref.reviewProfile,
    onEmailClick = _ref.onEmailClick;
  return ___EmotionJSX("div", {
    css: styles.sideboxCard
  }, agencyLogo && ___EmotionJSX("div", {
    css: styles.agencyBranding(agencyLogoBackgroundColour)
  }, ___EmotionJSX("img", {
    css: styles.logo,
    src: agencyLogo,
    alt: ""
  })), ___EmotionJSX("div", {
    css: styles.body
  }, ___EmotionJSX("div", {
    css: styles.profile
  }, ___EmotionJSX(Avatar, {
    css: styles.avatar,
    imageUrl: profilePhoto,
    imageTitle: name,
    shape: "circle",
    colorScheme: "dark"
  }), ___EmotionJSX("div", {
    css: styles.details
  }, ___EmotionJSX("div", {
    css: styles.name
  }, name), ___EmotionJSX("a", {
    css: styles.title,
    href: agencyProfileUrl
  }, title)), (reviewProfile === null || reviewProfile === void 0 ? void 0 : reviewProfile.reviewCount) > 0 && ___EmotionJSX(AverageStarRatingAndTotal, {
    size: "m",
    averageRating: reviewProfile.overallRating,
    totalReviews: reviewProfile.reviewCount
  })), ___EmotionJSX("div", {
    css: styles.buttons
  }, isEmailContactable && ___EmotionJSX(AllhomesNonEuUser, null, ___EmotionJSX(Button, {
    appearance: "outline",
    icon: ___EmotionJSX(EmailIcon, null),
    onClick: () => onEmailClick(false)
  }, "Email")), ___EmotionJSX(CallButton, {
    css: styles.callButton,
    phone: phoneNumber
  }), ___EmotionJSX(Separator, null), isEmailContactable && ___EmotionJSX(AllhomesNonEuUser, null, ___EmotionJSX(Button, {
    appearance: "primary",
    onClick: () => onEmailClick(true)
  }, "Looking to sell? Get a free appraisal")))));
};